import styled from 'styled-components';
import { FiArrowLeft } from 'react-icons/fi';
import { AiOutlineLike } from 'react-icons/ai';

import WrapperFlex from '../../molecules/WrapperFlex';

export const Container = styled(WrapperFlex)`
  min-height: 350px;
  display: flex;
  align-items: flex-start;
`;

export const IconPrev = styled(FiArrowLeft)`
  margin-right: 5px;
  margin-top: 2px;
`;

export const IconLike = styled(AiOutlineLike)`
  margin-right: 5px;
  margin-top: 2px;
`;

export const ContainerFooter = styled.div`
  margin-top: 20px;
`;
